import React, { useContext, useEffect, useRef, useState } from "react";
import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
  useMap,
} from "react-leaflet";
import "../../public/assets/css/main.css";
import "leaflet/dist/leaflet.css";
import mrkricon from "leaflet/dist/images/marker-icon.png";
import mrkriconShadow from "leaflet/dist/images/marker-shadow.png";

const Map = () => {
  const mapRef = useRef(null);
  const [location, setLocation] = useState([-38.0190009, -57.5263994]);

  useEffect(() => {
    handleGetLocation();
  }, []);

  const handleGetLocation = async () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setLocation({ latitude, longitude });
      },
      (error) => {
        console.error("Error obteniendo la ubicación:", error);
      }
    );
  };

  const centerPoint = location;
  let DefaultIcon = L.icon({
    iconUrl: mrkricon,
    shadowUrl: mrkriconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });
  L.Marker.prototype.options.icon = DefaultIcon;

  return (
    <div className="mapContainer">
      <MapContainer
        ref={mapRef}
        style={{ width: "500px", height: "500px" }}
        center={centerPoint}
        zoom={13}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </MapContainer>
    </div>
  );
};

export default Map;
